export default __webpack_public_path__ + "static/media/pic1.478bb693.jpg";